webpackJsonp([154094564729717],{

/***/ 381:
/***/ (function(module, exports) {

	module.exports = {"advantages":["Tax treatment. The IRS does not consider an operating lease to be a purchase, but rather a tax-deductible overhead expense. Therefore, you can deduct the lease payments from your corporate income.","Balance sheet management. Because an operating lease is not considered a long-term debt or liability, it does not appear as debt on your financial statement, thus making you more attractive to traditional lenders when you need them.","100% financing. With leasing, there is very little money down - perhaps only the first and last month's payment is due at the time of the lease. Since a lease does not require a down payment, it is equivalent to 100% financing. That means that you will have more money to invest in revenue-generating activities.","Immediate write-off of the dollars spent. Therefore, the equipment does not have to be depreciated over five to seven years.","Flexibility. As your business grows and your needs change, you can add or upgrade at any point during the lease term through add-on or master leases. If you anticipate growth, be sure to negotiate that option when you structure your lease program. You also have the option to include installation, maintenance and other services, if needed.","Customized solutions. A variety of leasing products is available, allowing you to tailor a program to fit your month-to-month or year-to-year cash flow needs. You are able to customize a program to address your needs and requirements - cash flow, budget, transaction structure, cyclical fluctuations, etc. Some leases allow you, for example, to miss one or more payments without a penalty; an important feature for seasonal businesses.","Asset management. A lease provides the use of equipment for specific periods of time at fixed payments. It assumes and manages the risk of equipment ownership. At the end of the lease, the lessor may dispose of the equipment.","Upgraded technology. If the nature of your industry demands that you have the latest technology, a short-term operating lease can help you get the equipment and keep your cash. Lease equipment that you expect to depreciate quickly. Your risk of getting caught with obsolete equipment is lower because you can upgrade or add equipment to meet your ever-changing needs.","Speed. Leasing can allow you to meet the need to respond quickly to new opportunities with minimal documentation and red tape. Many leasing companies approve your application within one or two days and you can have your equipment very quickly."]}

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	var _goodBusiness = __webpack_require__(381);
	
	__webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['why', 'press', 'history', 'questions', 'case-study', 'lease-loan', 'good-business'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'good-hero' },
	      _react2.default.createElement('div', { className: 'good-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'good-title' },
	      'Good Business'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'good-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'why', current: 'good-business' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'good-opener' },
	        'You rely on equipment every day to operate and grow your business. But the value of that equipment comes from using it, not owning it. By leasing, you transfer the uncertainties and risks of equipment ownership to the lessor, which allows you to concentrate on using that equipment as a productive part of your business.'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'advantages-opener' },
	        'Leasing offers numerous advantages over other financing methods:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'advantages-list' },
	        _goodBusiness.advantages.map(function (advantage, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: 'advantage' },
	            advantage
	          );
	        })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-why-good-business-js-bf548386fa05c9cd4550.js